import React from 'react';
import { Typography, Button, Grid, TextField, Checkbox, FormControlLabel } from '@mui/material';

import axios from '../../utils/axios.utils';

interface NewGtinPrefixFormProps {
  onSuccess: () => void;
  showSnackbar?: (message: string, severity: 'success' | 'error') => void;
}

const NewGtinPrefixForm: React.FC<NewGtinPrefixFormProps> = ({ onSuccess, showSnackbar = () => {} }) => {
  const [formValues, setFormValues] = React.useState({
    prefix: '',
    company: '',
    description: '',
    active: true,
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormValues(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await axios.post('/api/admin/autotreat_mfr/gtin_prefixes/', formValues, {
        headers: { 
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
          'Content-Type': 'application/json',
        },
      });
      
      showSnackbar('GTIN prefix created successfully!', 'success');
      onSuccess();
    } catch (err: any) {
      console.error('Failed to create GTIN Prefix:', err);
      const errorMessage = err?.response?.data?.message || 'Failed to create GTIN prefix. Please try again.';
      showSnackbar(errorMessage, 'error');
    }
  };

  return (
    <form id="dialog-form" onSubmit={handleSubmit}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField 
            name="prefix" 
            label="Prefix" 
            fullWidth 
            variant="outlined" 
            required 
            value={formValues.prefix} 
            onChange={handleChange}
            inputProps={{
              maxLength: 15
            }}
            helperText={`${formValues.prefix.length}/15 characters`}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField name="company" label="Company" fullWidth variant="outlined" value={formValues.company} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField name="description" label="Description" fullWidth variant="outlined" value={formValues.description} onChange={handleChange} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControlLabel control={<Checkbox name="active" checked={formValues.active} onChange={handleChange} />} label="Active" />
        </Grid>
      </Grid>
    </form>
  );
};

export default NewGtinPrefixForm;
